import React, { useState} from "react";
import styles from "./BaseList.module.css";
import Editing from "./Editing.jsx";

const Correct = () => {
  const [selected, setSelected] = useState("Մուտքագրում");

  return (
    <div className={styles["View-Correct-main-div"]}>
      <div className={styles["Correct-Mode-div"]}>
      </div>

      {selected && (
        <div className={styles["Selection-window"]}>
          <Editing selectedMode={selected} />
        </div>
      )}
    </div>
  );
};

export default Correct;
